import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {collectErrors} from '../../_utils/forms';

/**
 * @see {@link StandardSubjectFormComponent}
 */
@Component({
    selector: 'app-submittable-subject-form-base',
    template: '<div></div>'
})
export abstract class SubjectFormBaseComponent {

  @Input() subjectFormGroup: UntypedFormGroup;

  @Output() submittedData: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();
  @Output('formSubmitted') _formSubmittedEmitter = new EventEmitter<boolean>();

  private _formSubmitted: boolean = false;

  protected constructor() {

  }

  public onSubmit(): void {
    this.formSubmitted = true;
    if(this.f.valid) {
      this.submittedData.emit(this.f);
    } else {
      console.debug(`Validation errors: ${JSON.stringify(collectErrors(this.f))}`);
      if((this.f as any).hasOwnProperty('identification')) {
        console.debug(`Identification Validation errors: ${JSON.stringify(collectErrors(this.f.get('identification') as UntypedFormGroup))}`);
      }
    }
  }

  get formSubmitted(): boolean {
    return this._formSubmitted;
  }

  set formSubmitted(value: boolean) {
    this._formSubmitted = value;
    this._formSubmittedEmitter.emit(value);
  }

  public onBack(): void {
    this.back.emit();
  }

  public get f(): UntypedFormGroup {
    return this.subjectFormGroup;
  }

  public set f(formGroup: UntypedFormGroup) {
    this.subjectFormGroup = formGroup;
  }

  public get c(): {[p: string]: AbstractControl} {
    return this.f.controls;
  }

}
